import React , { useState, useEffect } from 'react';
import { Select } from '@windmill/react-ui';
import RegistrationTypeServices from 'services/RegistrationTypeServices';
const SelectRegType = ({register, name, label, selectedTransHead, setSelectedTransHead, 
  setSelecetedCompanyTypeName
  }) => {
  const [profiles, setProfiles] = useState([]);

  useEffect(() => {
    async function fetchProfiles() {
      try {
        const response = await RegistrationTypeServices.getAllRegistrationType();
        setProfiles(response.data); 
      } catch (error) {
        console.error('Error fetching Transport Head:', error);
      }
    }
  
    fetchProfiles();
  }, []);

  useEffect(() => {
    if (selectedTransHead && profiles.length > 0) {
      const selectedProfile = profiles.find((profile) => Number(profile.id) === Number(selectedTransHead));
      setSelecetedCompanyTypeName(selectedProfile ? selectedProfile.name : "");
    }
    // eslint-disable-next-line
  }, [selectedTransHead, profiles]);

  const handleChange = (e) => {
    const selectedId = e.target.value;
  setSelectedTransHead(selectedId);

  const selectedProfile = profiles.find(profile => profile.id === selectedId);
  setSelecetedCompanyTypeName(selectedProfile ? selectedProfile.name : "");
  };
  return (
    <Select
    className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
    name={name}
    value={selectedTransHead || ""}
    {...register(`${name}`, {
      required: `${label} is required!`,
    })}
    onChange={handleChange}  
  >
    <option value="" hidden>Select Company Type</option>
    {Array.isArray(profiles) && profiles.length > 0 ? (
      profiles.map((profile) => (
        <option key={profile.id} value={profile.id}>
          {profile.name}
        </option>
      ))
    ) : (
      <option>Loading...</option>
    )}
  </Select>
    
  );
};

export default SelectRegType;
